import { useApiQuery } from "app/modules/api-client";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";

import { buildCampaignsExportParams } from "./campaignsExportParams";

export const useExcelCount = (
    selectedDomain: string,
    search?: string,
    sort?: { asc: boolean; sort: string },
    enabled = true,
) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();

    const { data, isLoading, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adIntelligenceAdvertiserCampaignsExcelCountList",
            options: {
                enabled,
                select: (response) => response?.totalRows,
            },
        },
        buildCampaignsExportParams(params, selectedDomain, search, sort),
    );

    return { excelCount: data, isLoading, isError };
};
